import { registerIntegration } from "@p0security/shared/integrations/registry";
import {
  type AnyFilterSchema,
  Registration,
} from "@p0security/shared/integrations/types";

import { ServiceNowAiAccesses } from "./accesses.ts";
import { ServiceNowAiComponents } from "./components.ts";
import { ServiceNowAiIconUrl } from "./icon.ts";

const ServiceNowAiFilters = {
  instance: { keys: ["value"] },
  role: { keys: ["name"] },
} as const satisfies AnyFilterSchema;
export type ServiceNowAiFilters = typeof ServiceNowAiFilters;

export const ServiceNowAiRegistration = Registration({
  accesses: ServiceNowAiAccesses,
  category: "resource",
  components: ServiceNowAiComponents,
  docs: {
    install: "agentic-gateway/mcp-server/servicenow",
    request: "agentic-gateway/requesting-access",
  },
  filters: ServiceNowAiFilters,
  identifier: "Instance name",
  itemKind: "instance",
  label: "ServiceNow (AI)",
  logoUrl: ServiceNowAiIconUrl,
  maturity: "beta",
  requestType: "requestable",
  useMapping: [{ use: "iam_write", component: "instance" }],
});

registerIntegration("servicenow-ai", ServiceNowAiRegistration);
